import { useSyncExternalStore } from "react";

export type SyncStatus = "offline" | "syncing" | "synced" | "error";

let status: SyncStatus = "offline";
const listeners = new Set<() => void>();

export function setSyncStatus(next: SyncStatus): void {
  if (next === status) return;
  status = next;
  listeners.forEach((listener) => listener());
}

export function getSyncStatus(): SyncStatus {
  return status;
}

export function useSyncStatus(): SyncStatus {
  return useSyncExternalStore(
    (callback) => {
      listeners.add(callback);
      return () => {
        listeners.delete(callback);
      };
    },
    getSyncStatus,
  );
}

let retryHandler: (() => void) | null = null;

/** 設定頁「重試」按鈕的入口 */
export function retrySync(): void {
  retryHandler?.();
}

export function setRetryHandler(handler: (() => void) | null): void {
  retryHandler = handler;
}
